/**
 * Store pour la gestion des templates des chartes graphiques
 */

import { defineStore } from 'pinia';
import axios from '@js/tools/axios';

import { useManagingUser } from '@compositions/ManagingUser.js';
import { useAbstractGraphicalLineTemplateStore } from '@stores/graphicalLineTemplate/abstractGraphicalLineTemplateStore.js';

export const useDefaultGraphicalLineTemplateStore = defineStore('defaultGraphicalLineTemplate', (() => {

    // Composition pour l'utilisateur que l'on gère
    const { getManagingUser } = useManagingUser({});

    const {
        getTemplateList,
        getTemplateById,
        loadTemplateList,
        updateTemplate,
        removeTemplate,
        duplicateTemplate,
        resetTemplateList,
        resetRestorationState,
        setTemplateList
    } = useAbstractGraphicalLineTemplateStore({
        templateType: null
    });

    /**
     * Chargement de la liste des templates par catégorie de publication (informationnel, promotionnel, conseil)
     * @return Promise
     */
    const loadTemplateListByPostCategory = (() => {

        const path = `/api/users/${ getManagingUser.value.id }/graphical-line-templates/by-post-category`;

        return axios.get(path).then((response) => {

            const success = (response?.data?.success ?? false);
            const templatesByCategory = (response?.data?.templatesByCategory ?? null);

            if(! success || templatesByCategory === null) {
                return Promise.reject();
            }

            return Promise.resolve(templatesByCategory);
        });

    });

    return {
        getTemplateList,
        getTemplateById,
        loadTemplateList,
        updateTemplate,
        removeTemplate,
        duplicateTemplate,
        resetTemplateList,
        resetRestorationState,
        setTemplateList,
        loadTemplateListByPostCategory
    };
}));
